import React from 'react'

import './styles.scss'
import { ITableSimpleProps } from './interface'

const bc = 'table-simple'

const renderHeader = (headers: string[]) => (
  <thead>
    <tr>
      {headers.map((header: string, i: number) => (
        <th key={`header_${i}`}>{header}</th>
      ))}
    </tr>
  </thead>
)

const TableSimple: React.FC<ITableSimpleProps> = ({
  headers,
  data,
  renderBody,
  customClassName = '',
  bodyClassName = '',
}) => (
  <table className={`${bc}__table ${customClassName}`}>
    {renderHeader(headers)}
    <tbody className={bodyClassName}>{renderBody(data)}</tbody>
  </table>
)

export default TableSimple
